export * from '@platform/services/config/public-api';
